import { useTranslation } from 'react-i18next';

import { useExportVariance } from '../../queries';
import type { ExportFormat, VarianceFilters } from '../../types';
import { Button } from '@/shared/ui/atoms/Button';
import { Icon } from '@/shared/ui/atoms/Icon';
import { useToast } from '@/shared/ui/organisms/Toast/useToast';
import './ExportButtons.styl';

type Props = { filters: VarianceFilters };

export function ExportButtons({ filters }: Props) {
  const exp = useExportVariance();
  const toast = useToast();
  const { t } = useTranslation(undefined, { keyPrefix: 'insights.export' });
  const run = (format: ExportFormat) =>
    exp.mutate({ filters, format }, { onSuccess: (name) => toast.show(t('done', { name }), 'success'), onError: () => toast.show(t('error'), 'error') });
  const busy = exp.isPending;
  return (
    <>
      <Button variant="ghost" className="f-export f-export--sheet" onClick={() => run('csv')} disabled={busy} iconLeft={<Icon name="fileCsv" size={14} />}>
        {t('csv')}
      </Button>
      <Button variant="ghost" className="f-export f-export--sheet" onClick={() => run('xlsx')} disabled={busy} iconLeft={<Icon name="fileExcel" size={14} />}>
        {t('xlsx')}
      </Button>
      <Button variant="ghost" className="f-export f-export--pdf" onClick={() => run('pdf')} loading={busy} iconLeft={<Icon name="filePdf" size={14} />}>
        {t('pdf')}
      </Button>
    </>
  );
}
